import SignUpForm from '@/components/forms/auth/SignUpForm'
import { Meta } from '@cfs-fixings/shared'

function SignUpPage () {
  return <>
    <Meta title="Sign Up" />

    <div className="flex justify-center w-full mt-[110px]">
      <SignUpForm />
    </div>
  </>
}

export default SignUpPage
